/**
 * Base64 Decode Command
 * Decode Base64 strings
 */
import { Command } from 'commander';
import { readFile, writeFile } from 'fs/promises';
import { UtilsService } from '../../services/utils.service.js';

async function handleBase64Decode(
    input: string | undefined,
    options: {
        file?: string;
        output?: string;
    }
): Promise<void> {
    const service = new UtilsService();

    try {
        let encodedInput: string;

        if (options.file) {
            encodedInput = await readFile(options.file, 'utf-8');
        } else {
            if (!input) {
                console.error('❌ Please provide Base64 input or use --file option');
                process.exit(1);
            }
            encodedInput = input;
        }

        const decoded = service.base64Decode(encodedInput.trim());

        if (options.output) {
            await writeFile(options.output, decoded);
            console.log('✅ Decoded and saved to:', options.output);
        } else {
            console.log('📝 Base64 Decoded:');
            console.log('────────────────────────────────────────');
            console.log();
            console.log(`   ${decoded.toString('utf-8')}`);
            console.log();
        }
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createBase64DecodeCommand(): Command {
    const cmd = new Command('base64-decode')
        .description('Decode Base64 string')
        .argument('[input]', 'Base64 string to decode')
        .option('-f, --file <path>', 'Decode from file')
        .option('-o, --output <path>', 'Write decoded output to file')
        .addHelpText('after', `
Examples:
  $ jai1 utils base64-decode "aGVsbG8gd29ybGQ="
  $ jai1 utils base64-decode --file ./encoded.txt
  $ jai1 utils base64-decode "aGVsbG8=" --output ./decoded.txt
  $ jai1 utils base64-decode --file ./encoded.txt --output ./image.png
`)
        .action(async (input, options) => {
            await handleBase64Decode(input, options);
        });

    return cmd;
}
